const deleteMinuses = (str: string) => str.replaceAll('-', '');

export default deleteMinuses;
